import { useEffect, useState } from "react";
import { useSiteClub } from "../lib/SiteClubContext";
import { Link } from "react-router-dom";
import { listArticles, type ArticleRow } from "../lib/api";

export default function ArticlesPage() {
  const [articles, setArticles] = useState<ArticleRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { club, loading: clubLoading } = useSiteClub();

  // On a club's own site, only that club's news.
  useEffect(() => {
    if (clubLoading) return;
    listArticles(club?.clubId)
      .then((res) => setArticles(res.articles))
      .catch((err) => setError(err instanceof Error ? err.message : "Failed to load news."));
  }, [club?.clubId, clubLoading]);

  return (
    <div>
      <h1>{club ? `${club.name} news` : "News"}</h1>
      {error && <p className="err">{error}</p>}
      {!articles && !error && <p className="muted">Loading…</p>}
      {articles && articles.length === 0 && <p className="muted">No news posted yet.</p>}
      <div className="events-grid">
        {articles?.map((a) => (
          <Link key={a.articleId} to={`/news/${a.articleId}`} className="card event-card">
            <h3>{a.title}</h3>
            <p className="muted">
              {new Date(a.publishDate || a.createdAt).toLocaleDateString(undefined, {
                month: "short",
                day: "numeric",
                year: "numeric",
              })}
            </p>
            {a.summary && <p>{a.summary}</p>}
          </Link>
        ))}
      </div>
    </div>
  );
}
